import {
  Text,
  TextAlignment,
  TokenTextAppearance,
  styled,
} from '@volkswagen-onehub/components-core';
import { useTranslation } from 'react-i18next';
import { minimalScreenWidth } from '@/common/breakpoints';

const StyledContainer = styled.h1`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-left: ${(props) => props.theme.size.dynamic0150};
  padding-right: ${(props) => props.theme.size.dynamic0150};
  padding-top: ${(props) => props.theme.size.static250};
  padding-bottom: ${(props) => props.theme.size.static200};

  @media screen and ${minimalScreenWidth.l} {
    justify-content: left;
    padding-left: ${(props) => props.theme.size.dynamic0250};
    padding-right: ${(props) => props.theme.size.dynamic0250};
    padding-top: ${(props) => props.theme.size.static550};
    padding-bottom: ${(props) => props.theme.size.static510};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding-left: ${(props) => props.theme.size.dynamic0450};
    padding-right: ${(props) => props.theme.size.dynamic0450};
  }
`;

export const Welcome = (): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer data-testid="welcome-container">
      <Text bold textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline400}>
        {t(`header.greetings`)}
      </Text>
    </StyledContainer>
  );
};
